<div class="terms-content">
    <h1 class="fw-bold mb-2 display-6">Terms of Service</h1>
    <p class="text-secondary fst-italic mb-4">Last Updated: January 8, 2026</p>
    <section class="mb-5">
        <h4 class="fw-bold mb-3 h5">1. Acceptance of Terms</h4>
        <p class="text-muted leading-relaxed">
            By accessing and using publichome.page ("Service"), you agree to comply with and be bound by
            these Terms of Service. If you do not agree to these terms, please do not use our Service.
        </p>
    </section>

    <section class="mb-5">
        <h4 class="fw-bold mb-3 h5">2. Description of Service</h4>
        <p class="text-muted leading-relaxed">
            publichome.page provides a platform for users to create, publish, and manage content. We
            offer
            both free and paid subscription services.
        </p>
    </section>

    <section class="mb-5">
        <h4 class="fw-bold mb-3 h5">3. Accounts and Registration</h4>
        <p class="text-muted leading-relaxed">
            You must provide accurate and complete information when creating an account. You are
            responsible
            for maintaining the confidentiality of your account credentials and for all activities that
            occur under
            your account.
        </p>
    </section>

    <section class="mb-5">
        <h4 class="fw-bold mb-3 h5">4. Subscriptions and Payments</h4>
        <p class="text-muted leading-relaxed">
            Some features of the Service may require a paid subscription. By selecting a paid service,
            you
            agree
            to pay the fees indicated.
        </p>
        <ul class="text-muted mt-3">
            <li class="mb-3">
                <strong class="text-dark">Payment Processing:</strong> We use third-party payment
                processors
                such as PayPal and Stripe to handle
                secure payments. We do not store your full credit card information on our servers.
            </li>
            <li class="mb-3">
                <strong class="text-dark">Billing Cycle:</strong> Subscription fees are billed in
                advance on
                a recurring basis (monthly or annually)
                depending on your plan.
            </li>
            <li class="mb-3">
                <strong class="text-dark">Cancellations:</strong> You may cancel your subscription at
                any
                time. Your subscription will remain active
                until the end of the current billing period.
            </li>
            <li>
                <strong class="text-dark">Refunds:</strong> Payment made are non refundable, We have
                generous trial period, you can always
                cancel your subscription to stop future payments.
            </li>
        </ul>
    </section>

    <section class="mb-5">
        <h4 class="fw-bold mb-3 h5">5. Content and Conduct</h4>
        <p class="text-muted leading-relaxed">
            You retain ownership of the content you publish. However, by posting content, you grant us a
            license
            to use, store, and display your content in connection with providing the Service.
        </p>
        <p class="text-muted leading-relaxed mt-2">You agree not to use the Service to:</p>
        <ul class="text-muted mt-2">
            <li class="mb-2">Violate any laws or regulations.</li>
            <li class="mb-2">Infringe upon the rights of others.</li>
            <li class="mb-2">Distribute malware or malicious content.</li>
            <li>Engage in abusive or harassing behavior.</li>
        </ul>
    </section>

    <section class="mb-5">
        <h4 class="fw-bold mb-3 h5">6. Termination</h4>
        <p class="text-muted leading-relaxed">
            We reserve the right to suspend or terminate your account at our discretion if you violate
            these
            Terms of Service.
        </p>
    </section>

    <section class="mb-5">
        <h4 class="fw-bold mb-3 h5">7. Limitation of Liability</h4>
        <p class="text-muted leading-relaxed">
            To the maximum extent permitted by law, publichome.page shall not be liable for any
            indirect,
            incidental, special, or consequential damages arising out of or in connection with your use
            of
            the
            Service.
        </p>
    </section>

    <section class="mb-5">
        <h4 class="fw-bold mb-3 h5">8. Changes to Terms</h4>
        <p class="text-muted leading-relaxed">
            We may modify these terms at any time. We will notify you of significant changes by posting
            the
            new terms on this page.
        </p>
    </section>
</div>